import { render, staticRenderFns } from "./EmbeddedAppsDisplay.vue?vue&type=template&id=8a9f7f5a&scoped=true"
import script from "./EmbeddedAppsDisplay.vue?vue&type=script&lang=js"
export * from "./EmbeddedAppsDisplay.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedAppsDisplay.vue?vue&type=style&index=0&id=8a9f7f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9f7f5a",
  null
  
)

export default component.exports